module.exports = __webpack_public_path__ + "static/card-bg@2x.bb6c1b3c.png";